"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIAbstractNumberInput = _interopRequireDefault(require("./abstract/UIAbstractNumberInput"));

var _UITextInput = _interopRequireDefault(require("./UITextInput"));

var _Functions = require("../core/Functions");

var UINumberInput = _react.default.createClass({
  displayName: "UINumberInput",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UITextInput.default.propTypes, ['type']), (0, _omit.default)(_UIAbstractNumberInput.default.propTypes, ['children'])),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UITextInput.default.defaultProps, _UIAbstractNumberInput.default.defaultProps);
  },
  focus: function focus() {
    if (this._inputRef) {
      this._inputRef.focus();
    }
  },
  select: function select() {
    if (this._inputRef) {
      this._inputRef.select();
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
    (0, _Functions.callIfPossible)(ref);
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        type = _this$props.type,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "type"]);

    if (type !== _UITextInput.default.defaultProps.type) {
      _devLogger.default.warn({
        message: 'UINumberInput: The `type` prop is a no-op (#4178)',
        key: 'UINumberInput: type'
      });
    }

    return _react.default.createElement(_UIAbstractNumberInput.default, props, function (numberProps) {
      return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, numberProps, {
        className: (0, _classNames.default)('uiNumberInput', className),
        ref: _this.inputRefCallback,
        type: "text"
      }));
    });
  }
});

var _default = (0, _Controllable.default)(UINumberInput);

exports.default = _default;
module.exports = exports.default;